import {
  cloneElement,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";
import { TabulatorFull } from "tabulator-tables";
import "./Tabulator.scss";
import { createRoot } from "react-dom/client";

export type EventsType = { event: string; callback: Function }[];
type Props = {
  events?: EventsType;
  options: any;
};

export function reactFormatter(JSX: any) {
  return function customFormatter(
    cell: any,
    formatterParams: any,
    onRendered: (callback: () => void) => void
  ) {
    // cell - the cell component
    // formatterParams - parameters set for the column
    // onRendered - function to call when the formatter has been rendered
    const renderFn = () => {
      const cellEl = cell.getElement();
      if (cellEl) {
        const formatterCell = cellEl.querySelector(".formatterCell");
        if (formatterCell) {
          const CompWithMoreProps = cloneElement(JSX, { cell });
          const root = createRoot(formatterCell);
          root.render(CompWithMoreProps);
        }
      }
    };

    if (onRendered) {
      onRendered(renderFn); // initial render only.
    }

    setTimeout(() => {
      renderFn(); // render every time cell value changed.
    }, 0);
    return '<div class="formatterCell"></div>';
  };
}

const Tabulator = forwardRef(({ events, options }: Props, ref) => {
  const domNodeRef = useRef<any>(null);
  const tabulatorInstanceRef = useRef<any>(null);

  useImperativeHandle(
    ref,
    () => ({
      getTableInstance: () => tabulatorInstanceRef.current,
    }),
    []
  );

  useEffect(() => {
    tabulatorInstanceRef.current = new TabulatorFull(
      domNodeRef.current,
      options
    );

    if (events) {
      events.forEach((item) => {
        tabulatorInstanceRef.current.on(item.event, item.callback);
      });
    }

    return () => {
      // Cleanup: Destroy Tabulator instance
      if (tabulatorInstanceRef.current) {
        tabulatorInstanceRef.current.destroy();
        if (events) {
          events.forEach((item) => {
            tabulatorInstanceRef.current.off(item.event, item.callback);
          });
        }
        tabulatorInstanceRef.current = null;
      }
    };
  }, [events, options]);
  return <div style={{ width: "100%", height: "100%" }} ref={domNodeRef}></div>;
});

export default Tabulator;
